function initDecorHoverEffect(sectionSelector, decorSelector) {
  document.querySelectorAll(sectionSelector).forEach((section) => {
    const ellipses = section.querySelectorAll(decorSelector);
    if (ellipses.length < 2) return;

    const redEllipse = ellipses[0];
    const blueEllipse = ellipses[1];

    if (window.innerWidth > 1024) {
      let targetX = 0, targetY = 0;
      let currentX1 = 0, currentY1 = 0;
      let currentX2 = 0, currentY2 = 0;
      let isHover = false;
      let rafId = null;

      const easeHover1 = 0.15;
      const easeHover2 = 0.01;
      const easeReturn = 0.05;

      function animate() {
        const ease1 = isHover ? easeHover1 : easeReturn;
        const ease2 = isHover ? easeHover2 : easeReturn;

        currentX1 += (targetX - currentX1) * ease1;
        currentY1 += (targetY - currentY1) * ease1;

        currentX2 += (targetX - currentX2) * ease2;
        currentY2 += (targetY - currentY2) * ease2;

        redEllipse.style.left = `${currentX1}px`;
        redEllipse.style.top = `${currentY1}px`;
        redEllipse.style.transform = 'translate(-50%, -50%)';

        blueEllipse.style.left = `${currentX2}px`;
        blueEllipse.style.top = `${currentY2}px`;
        blueEllipse.style.transform = 'translate(-50%, -50%)';

        const isMoving =
          Math.abs(targetX - currentX1) > 0.1 ||
          Math.abs(targetY - currentY1) > 0.1 ||
          Math.abs(targetX - currentX2) > 0.1 ||
          Math.abs(targetY - currentY2) > 0.1;

        if (isMoving) {
          redEllipse.classList.add('is-controlled');
          blueEllipse.classList.add('is-controlled');

          redEllipse.classList.remove('is-idle');
          blueEllipse.classList.remove('is-idle');

          rafId = requestAnimationFrame(animate);
        } else {
          rafId = null;

          redEllipse.classList.remove('is-controlled');
          blueEllipse.classList.remove('is-controlled');

          redEllipse.classList.add('is-idle');
          blueEllipse.classList.add('is-idle');
        }
      }

      function updateTargetFromEvent(e) {
        const rect = section.getBoundingClientRect();
        targetX = Math.min(Math.max(e.clientX - rect.left, 10), rect.width - 10);
        targetY = Math.min(Math.max(e.clientY - rect.top, 10), rect.height - 10);
        if (!rafId) animate();
      }

      section.addEventListener('mouseenter', (e) => {
        isHover = true;
        redEllipse.style.transition = 'none';
        blueEllipse.style.transition = 'none';
        updateTargetFromEvent(e);
      });

      section.addEventListener('mousemove', (e) => {
        if (!isHover) return;
        updateTargetFromEvent(e);
      });

      section.addEventListener('mouseleave', () => {
        isHover = false;
        redEllipse.style.transition = 'none';
        blueEllipse.style.transition = 'none';

        const rect = section.getBoundingClientRect();
        targetX = rect.width / 2;
        targetY = rect.height / 2;

        if (!rafId) animate();
      });

      const rect = section.getBoundingClientRect();
      currentX1 = rect.width / 2;
      currentY1 = rect.height / 2;
      currentX2 = rect.width / 2;
      currentY2 = rect.height / 2;

      redEllipse.style.left = `${currentX1}px`;
      redEllipse.style.top = `${currentY1}px`;
      blueEllipse.style.left = `${currentX2}px`;
      blueEllipse.style.top = `${currentY2}px`;

      redEllipse.style.transform = 'translate(-50%, -50%)';
      blueEllipse.style.transform = 'translate(-50%, -50%)';

      redEllipse.classList.add('is-idle');
      blueEllipse.classList.add('is-idle');
    }
  });
}

initDecorHoverEffect('.employers-sec', '.employers-sec__ellipse');
initDecorHoverEffect('.single-page-404', '.single-page-404__ellipse');
